/*
 * Oh Yuk — GA4 custom event tracking.
 *
 * Fires ecommerce + funnel events that Shopify's native GA4 integration misses:
 *   view_cart          — when the cart drawer opens
 *   select_promotion   — when the BOGO bundle pill is clicked
 *   view_item_list     — when a collection page renders
 *   select_item        — when a product card is clicked
 *   subscribe_selected — when "Subscribe and save" is picked on a PDP
 *   bundle_unlocked    — when the cart reaches 3+ items (BOGO threshold)
 *   search             — when a user lands on /search with a query string
 *
 * Uses window.gtag (provided by Shopify's Google channel). All calls are wrapped
 * in `if (typeof gtag === 'function')` to fail safe if the tag isn't loaded.
 */
(function () {
  function safeGtag() {
    if (typeof window.gtag !== 'function') return;
    try { window.gtag.apply(null, arguments); } catch (e) { /* no-op */ }
  }

  // --- view_cart: fire when the cart drawer opens ---
  // The cart drawer adds class "active" to <cart-drawer> when opened.
  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('active');
      if (isOpen && !wasOpen) fireViewCart();
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function fireViewCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) {
          return {
            item_id: String(i.product_id),
            item_name: i.product_title,
            item_variant: i.variant_title || '',
            price: i.final_price / 100,
            quantity: i.quantity
          };
        });
        safeGtag('event', 'view_cart', {
          currency: (cart.currency || 'USD'),
          value: cart.total_price / 100,
          items: items
        });
        // Bonus signal: if the cart just hit the BOGO threshold, log that too.
        if (cart.item_count >= 3) {
          safeGtag('event', 'bundle_unlocked', {
            currency: cart.currency || 'USD',
            value: cart.total_price / 100,
            item_count: cart.item_count
          });
        }
      })
      .catch(function () {});
  }

  // --- select_promotion: BOGO pill clicks on the PDP ---
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ohyuk-bogo-pill');
    if (pill) {
      safeGtag('event', 'select_promotion', {
        promotion_id: 'buy_2_get_3rd_50',
        promotion_name: 'Buy 2 Get 3rd 50% Off',
        creative_slot: 'pdp_pill'
      });
      return;
    }
    // --- select_item: product cards on collection and homepage ---
    var card = e.target.closest('a.full-unstyled-link[href*="/products/"], a.card[href*="/products/"], .card-wrapper a[href*="/products/"]');
    if (card) {
      var url = new URL(card.href, window.location.origin);
      var handle = url.pathname.split('/products/')[1];
      if (handle) {
        safeGtag('event', 'select_item', {
          item_list_id: (window.ohyukListId || 'unknown'),
          item_list_name: (window.ohyukListName || 'unknown'),
          items: [{ item_id: handle.split('?')[0], item_name: card.textContent.trim().slice(0, 80) }]
        });
      }
    }
  });

  // --- subscribe_selected: when the "Subscribe and save" radio is picked on a PDP ---
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var label = t.closest('label')?.textContent?.toLowerCase() || '';
    if (label.indexOf('subscribe') !== -1) {
      var productEl = document.querySelector('[data-product-id], product-info');
      var productId = productEl?.dataset?.productId || '';
      safeGtag('event', 'subscribe_selected', {
        item_id: productId,
        item_name: document.querySelector('.product__title h1')?.textContent?.trim() || ''
      });
    }
  });

  // --- search: fire when landing on /search?q=... ---
  // Covers form submits (which navigate to /search?q=...) AND inbound deep links.
  function fireSearchIfOnResultsPage() {
    if (!/^\/search/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    var term = (params.get('q') || '').trim();
    if (!term) return;
    safeGtag('event', 'search', { search_term: term });
  }

  // Also catch predictive-search submits in case the user submits without navigating
  // (e.g. a custom element intercepts the form).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!/\/search/.test(form.getAttribute('action') || '')) return;
    var input = form.querySelector('input[name="q"]');
    var term = input && input.value ? input.value.trim() : '';
    if (term) safeGtag('event', 'search', { search_term: term });
  });

  // Init
  function init() {
    watchCartDrawer();
    fireSearchIfOnResultsPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
